import { z } from 'zod';
// Phase 17 — caregiver profile photo. Presigned-PUT upload (mirrors the
// credential / void-cheque upload pattern), client-side resized to a square
// before upload. `null` url → the frontend renders the default initials avatar.
/** Accepted image content types for a profile photo. */
export const ProfilePhotoContentTypeSchema = z.enum([
    'image/jpeg',
    'image/png',
    'image/webp',
]);
/** 5 MB cap on the (already client-resized) upload — a safety net, not the
 *  expected size (a 512px square JPEG is ~50–150 KB). */
export const PROFILE_PHOTO_MAX_BYTES = 5_242_880;
export const CaregiverProfilePhotoUploadUrlRequestSchema = z.object({
    contentType: ProfilePhotoContentTypeSchema,
    contentLength: z.number().int().positive().max(PROFILE_PHOTO_MAX_BYTES),
});
export const CaregiverProfilePhotoUploadUrlResponseSchema = z.object({
    /** Presigned PUT URL — client uploads the resized image directly. */
    uploadUrl: z.string().url(),
    /** Object-storage key to hand back on confirm. */
    key: z.string().min(1),
});
export const CaregiverProfilePhotoConfirmRequestSchema = z.object({
    key: z.string().min(1),
});
/** Current photo — `url` is a short-lived signed download URL, or null when
 *  no photo is set (frontend falls back to the default avatar). */
export const CaregiverProfilePhotoResponseSchema = z.object({
    url: z.string().url().nullable(),
    updatedAt: z.string().nullable(),
});
//# sourceMappingURL=profile-photo.schema.js.map